export default "__VITE_ASSET__BQO_FNL3__"